import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Navbar } from '@/components/super-admin/general';
import { superAdminNavItems } from '@/data/super-admin/general/navigationData';
import { EmployeeDetailContent } from '@/pages/admin/employees/EmployeeDetailContent';

/**
 * Super-admin view of a client organization's employee. Reuses the shared
 * employee detail content, scoping all data to the client's organization via
 * the `:clientId` route param (which is the organization id).
 */
export const ClientEmployeeDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { clientId, employeeId } = useParams<{ clientId: string; employeeId: string }>();

  return (
    <div className="min-h-screen">
      <Navbar navItems={superAdminNavItems} activeItem="Clientes" userName="A Admin" />

      <EmployeeDetailContent
        employeeId={employeeId}
        organizationId={clientId}
        mode="super-admin"
        onBack={() => void navigate(`/clientes/${clientId ?? ''}`)}
        backLabel="Volver al detalle del cliente"
      />
    </div>
  );
};
